export default __webpack_public_path__ + "static/media/image.fixel-digital.7d6d4d20.png";